import React, { useState, useEffect } from 'react'
import { useCompany } from 'models'
import collect from 'collect.js'
import DocumentService from 'services/document'
import { Button, Card, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LoginService from 'services/login'
import { faPlus, faPowerOff, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { maskDocument, validateDocument } from 'helpers/document'
import MaskedInput from 'react-text-mask'
import ResalesRequestService from 'services/resales-request'
import Swal from 'sweetalert2';
import { Clear } from '@material-ui/icons'
import { CNPJ } from 'helpers/Input'

import logo from '../../images/logo/logo_scansource_select_colorido.png'

import './style.css'

export default function AccessionForm() {
  const { company } = useCompany()
  const profiles = [
    { id: 4, name: 'Revenda Master' },
    { id: 7, name: 'Revenda Visuaizador' }
  ]
  const branches = collect(company.group_years)
    .where("fiscal_year_id", company.current_fiscal_year.id)
    .where("company_id", '!==', company.id)
    .all()
    .map((branch) => {
      return { id: branch.company_id, name: branch.name, alias: branch.alias, document: branch.document }
    })
  const users = collect(company.users)
    .whereIn("profile_id", [4, 6, 7])
    .all()
    .map(({ id, name, lastname, email, phone, profile_id }) => ({
      id, name, lastname, email, phone, profile_id
    }))

  const [contractAccept, setContractAccept] = useState(false)
  const [contractUri, setContractUri] = useState('')
  const [usersToDelete, setUsersToDelete] = useState([])
  const [companiesToDelete, setCompaniesToDelete] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [cName] = useState(company.name || "");
  const [cAlias] = useState(company.alias || "");
  const [cDocument] = useState(company.document);

  const [addressZipcode, setAddressZipcode] = useState(company.address_zipcode || "");
  const [address, setAddress] = useState(company.address || "");
  const [addressComplement, setAddressComplement] = useState(company.address_complement || "");
  const [addressNumber, setAddressNumber] = useState(company.address_number || "");
  const [addressNeighborhood, setAddressNeighborhood] = useState(company.address_neighborhood || "");
  const [addressState, setAddressState] = useState(company.address_state || "");
  const [addressCity, setAddressCity] = useState(company.address_city || "");

  const [showModalConfirm, setShowModalConfirm] = useState(false)

  const [branchesState, setBranches] = useState(branches);
  const [usersState, setUsers] = useState(users);

  const [branchesErrorState, setBranchesErrorState] = useState(branchesState.map(() => []));
  const [usersErrorState, setUsersErrorState] = useState(usersState.map(() => ({
    name: [],
    lastname: [],
    email: [],
    profile_id: []
  })));

  useEffect(() => {
    DocumentService.getContract()
      .then(r => {
        setContractUri(r.data.document_url)
        //console.log(r)
      })
  }, [])

  const logout = async () => {
    try {
      await LoginService.logout();
    } catch (error) {
    } finally {
      localStorage.clear();
      window.location.reload();
    }
  };

  function showCategory(category) {
    return <img src={logo} className="" alt="elite" width="300" />
  }

  function getProfileName(id) {
    return profiles.filter(p => p.id == id)[0]?.name
  }

  function handleChange(prop, val) {
    //setData({ ...data, [prop]: val })
  }

  function push(array, data, set) {
    array.push(data)
    set([...array])
  }

  function remove(array, index, set) {
    array.splice(index, 1);
    set([...array])
  }

  async function handleBranchChange(index, prop, value) {
    const updatedBranches = branchesState.map((branch, i) => (
      i === index ? { ...branch, [prop]: value } : branch
    ));
    setBranches([...updatedBranches]);

    if (prop === 'document') {
      const errors = [];

      if (value.length == 0)
        errors.push('CNPJ é obrigatório')

      if (!value.includes("_") && value.length > 0) {
        if (!validateDocument("cnpj", value)) {
          errors.push('CNPJ inválido');
        }

        try {
          value = value.replace(/[^\w\s]/gi, '')
          const res = await ResalesRequestService.verifyAlreadyExists(value)
          if (!res.data.available) {
            errors.push("A revenda ja pertence a outro grupo")
          }

          branchesState[index] = {
            ...branchesState[index],
            document: res.data.company.document,
            name: res.data.company.name,
            alias: res.data.company.alias
          }

          setBranches([...branchesState])
        } catch (err) {
          errors.push(err.response.data.message)
        }
      }

      const _branchesErrorState = branchesErrorState.map((error, i) => {
        return i === index ? errors : error
      });
      setBranchesErrorState([..._branchesErrorState]);
    }
  }

  const isValidName = (name) => {
    return name.trim().length > 0;
  };

  const isValidLastname = (lastname) => {
    return lastname.trim().length > 0;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidProfileId = (profileId) => {
    return Number.isInteger(profileId) && profileId > 0;
  };

  function handleUserChange(index, prop, value) {
    const updatedUsers = usersState.map((user, i) => (
      i === index ? { ...user, [prop]: value } : user
    ));
    setUsers([...updatedUsers]);

    const errors = []
    switch (prop) {
      case 'name':
        if (value.trim() == "")
          errors.push('Nome é obrigatório');
        if (!isValidName(value))
          errors.push('Nome inválido');
        if (value.length < 3)
          errors.push('O nome tem que ter no minimo 3 caracteres')
        break;
      case 'lastname':
        if (value.trim() == "")
          errors.push('Sobrenome é obrigatório');
        if (!isValidLastname(value))
          errors.push('Sobrenome inválido');
        if (value.length < 3)
          errors.push('O sobrenome tem que ter no minimo 3 caracteres')
        break;
      case 'email':
        if (value.trim() == "")
          errors.push('Email é obrigatório');
        if (!isValidEmail(value)) errors.push('Email inválido');
        break;
      case 'profile_id':
        if (value == "" || value == undefined)
          errors.push('Perfil é obrigatório');
        break;
      default:
        break;
    }

    const _usersErrorState = usersErrorState.map((error, i) => {
      return i === index ? { ...error, [prop]: errors } : error
    });
    setUsersErrorState([..._usersErrorState]);
  }

  const handleCloseModal = () => setShowModalConfirm(!showModalConfirm)

  function checkErrors() {
    for (let e of branchesErrorState) {
      if (e.length > 0)
        return true
    }

    for (let e of usersErrorState) {
      for (let i of Object.values(e)) {
        if (i.length > 0)
          return true
      }
    }
    return false
  }

  function handleSubmit() {
    const data = {
      id: company.id,
      name: cName,
      alias: cAlias,
      document: cDocument,
      address: address,
      address_number: addressNumber,
      address_complement: addressComplement,
      address_neighborhood: addressNeighborhood,
      address_zipcode: addressZipcode,
      address_city: addressCity,
      address_state: addressState,
      users_to_delete: usersToDelete.map(u => u.id),
      companies_to_delete: companiesToDelete.map(c => c.id),
      branches: branchesState,
      users: usersState
    }

    setIsLoading(true)
    ResalesRequestService
      .confirmAdhesion(data)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Adesão Realizada com sucesso!",
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: "Confirmar"
        })
          .then((result) => {
            if (result.isConfirmed)
              window.location.reload()
          })
      })
      .finally(() => {
        setIsLoading(false)
        setShowModalConfirm(false)
      })
  }

  useEffect(() => {
    DocumentService.getContract()
      .then(r => {
        setContractUri(r.data.document_url)
      })
  }, [])


  return (
    <div className='main'>
      <div className='div-fc'></div>
      <Container className="mt-5 mb-5">
        <Card className='shadow'>
          <Card.Header>
            <div className='d-flex justify-content-between'>
              <h2>Formulário de Adesão - {`FY${company.current_fiscal_year.fiscal_year.substr(2)}`}</h2>
              <Button variant="link" onClick={() => logout()}>
                Tentar mais tarde <FontAwesomeIcon icon={faPowerOff} color='#D71925' size='sm' />
              </Button>
            </div>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row>
                <Col md="12">
                  <h5 className="title-dashboard">Dados da Revenda</h5>
                  <hr className="line"></hr>
                </Col>
                <Col md="12">
                  <Row>
                    <Col md={6}>
                      <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                        {showCategory(company.is_premium)}
                      </div>
                    </Col>
                    <Col md="6">
                      <Row>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Razão Social:</Form.Label>
                            <Form.Control
                              name="name"
                              as="input"
                              value={cName}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Nome Fantasia:</Form.Label>
                            <Form.Control
                              name="alias"
                              as="input"
                              value={cAlias}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>CNPJ:</Form.Label>
                            <Form.Control
                              as="input"
                              disabled
                              value={maskDocument(cDocument)}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h5 className="title-dashboard">Endereço</h5>
                  <hr className="line"></hr>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>CEP:</Form.Label>
                    <MaskedInput
                      className='form-control'
                      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                      name="address_zipcode"
                      placeholder='00000-000'
                      value={addressZipcode}
                      onChange={(e) => setAddressZipcode(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group>
                    <Form.Label>Av. / Rua:</Form.Label>
                    <Form.Control
                      name="address"
                      as="input"
                      onChange={(e) => setAddress(e.target.value)}
                      value={address}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Número:</Form.Label>
                    <Form.Control
                      name="address_number"
                      as="input"
                      onChange={(e) => setAddressNumber(e.target.value)}
                      value={addressNumber}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Complemento:</Form.Label>
                    <Form.Control
                      name="address_complement"
                      as="input"
                      onChange={(e) => setAddressComplement(e.target.value)}
                      value={addressComplement}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Bairro:</Form.Label>
                    <Form.Control
                      name="address_neighborhood"
                      as="input"
                      onChange={(e) => setAddressNeighborhood(e.target.value)}
                      value={addressNeighborhood}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Cidade:</Form.Label>
                    <Form.Control
                      name="address_city"
                      as="input"
                      onChange={(e) => setAddressCity(e.target.value)}
                      value={addressCity}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Estado:</Form.Label>
                    <Form.Control
                      name="address_state"
                      as="select"
                      onChange={(e) => setAddressState(e.target.value)}
                      value={addressState}
                    >
                      <option>AC</option>
                      <option>AL</option>
                      <option>AP</option>
                      <option>AM</option>
                      <option>BA</option>
                      <option>CE</option>
                      <option>DF</option>
                      <option>ES</option>
                      <option>GO</option>
                      <option>MA</option>
                      <option>MT</option>
                      <option>MS</option>
                      <option>MG</option>
                      <option>PA</option>
                      <option>PB</option>
                      <option>PR</option>
                      <option>PE</option>
                      <option>PI</option>
                      <option>RJ</option>
                      <option>RN</option>
                      <option>RS</option>
                      <option>RO</option>
                      <option>RR</option>
                      <option>SC</option>
                      <option>SP</option>
                      <option>SE</option>
                      <option>TO</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='mt-5 mb-5'>
                <Col md="12" className="d-flex justify-content-between">
                  <h5 className="title-dashboard">Filiais</h5>
                  <span className='warning-msg small-text'>
                    <FontAwesomeIcon icon={faExclamationTriangle} className='mr-1' /> Necessário informar todos os CNPJs que desejem contabilizar no programa. Após a adesão, não será possível fazer inclusões.
                  </span>
                </Col>
                <Col md={12}><hr className="line"></hr></Col>
                {branchesState.map((branch, idx) => (
                  <React.Fragment key={idx}>
                    <Col md={5}>
                      <Form.Group>
                        <Form.Label>{idx + 1} - CNPJ:</Form.Label>
                        <CNPJ
                          value={branch.document}
                          onChange={e => handleBranchChange(idx, 'document', e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Razão Social:</Form.Label>
                        <Form.Control
                          as="input"
                          value={branch.name}
                          onChange={e => handleBranchChange(idx, 'name', e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Nome Fantasia:</Form.Label>
                        <Form.Control
                          as="input"
                          value={branch.alias}
                          onChange={e => handleBranchChange(idx, 'alias', e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Button style={{ position: 'relative', top: '33px' }} size='sm' variant="danger" onClick={() => {
                        Swal.fire({
                          title: 'Tem certeza ?',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          cancelButtonText: 'Não',
                          confirmButtonText: 'Sim!'
                        }).then((result) => {
                          if (result.isConfirmed) {

                            // if (user.id) {
                            //   let toDelete = [...usersToDelete]
                            //   toDelete.push(user)
                            //   setUsersToDelete([...toDelete])
                            // }
                            // remove(usersErrorState, idx, setUsersErrorState)
                            // remove(usersState, idx, setUsers)

                            if (branch.id) {
                              let toDelete = [...companiesToDelete]
                              toDelete.push(branch)
                              setCompaniesToDelete([...toDelete])
                            }

                            remove(branchesErrorState, idx, setBranchesErrorState)
                            remove(branchesState, idx, setBranches)
                          }
                        })
                      }}>
                        <Clear fontSize="small" />
                      </Button>
                    </Col>
                    <Col md="12">
                      <ul>
                        {branchesErrorState[idx]?.map((err, i) => (
                          <li key={i} style={{ color: 'red' }}>{err}</li>
                        ))}
                      </ul>
                    </Col>
                  </React.Fragment>
                ))}
                <Col md="12">
                  <Button onClick={() => {
                    push(branchesState, { name: "", alias: "", document: "" }, setBranches)
                    setBranchesErrorState([...branchesState.map(() => [])])
                  }}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar Filial
                  </Button>
                </Col>
              </Row>
              <Row className='mt-5 mb-5'>
                <Col md="12" className="d-flex justify-content-between">
                  <h5 className="title-dashboard">Usuários</h5>
                </Col>
                <Col md={12}><hr className="line"></hr></Col>
                {usersState.map((user, idx) => {
                  function getPhoneMask(phone){
                    let data = phone.replace("-"," ").split(" ");
                    if(data.length > 0){
                      // verificar se tem ref de pais
                      if(data[0].indexOf("+") != -1){
                        return ["+",/\d/,/\d/,' ','(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
                      }
                    }

                    return ["+",5,5,' ','(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
                  }
                  return (
                    <React.Fragment key={idx}>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>{idx + 1} - Nome:</Form.Label>
                          <Form.Control
                            as="input"
                            value={user.name}
                            onChange={e => handleUserChange(idx, 'name', e.target.value)}
                          />
                          {usersErrorState[idx] && (<>
                            <div className='display-errors small-text'>
                              {usersErrorState[idx]['name']?.map((err, i) => (<>
                                <li key={i} style={{ color: 'red' }}>{err}</li>
                              </>))}
                            </div>
                          </>)}
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>Sobrenome:</Form.Label>
                          <Form.Control
                            as="input"
                            value={user.lastname}
                            onChange={e => handleUserChange(idx, 'lastname', e.target.value)}
                          />
                          {usersErrorState[idx] && (<>
                            <div className='display-errors small-text'>
                              {usersErrorState[idx]['lastname']?.map((err, i) => (
                                <li key={i} style={{ color: 'red' }}>{err}</li>
                              ))}
                            </div>
                          </>)}
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label>Email:</Form.Label>
                          <Form.Control
                            as="input"
                            value={user.email}
                            onChange={e => handleUserChange(idx, 'email', e.target.value)}
                          />
                          {usersErrorState[idx] && (<>
                            <div className='display-errors small-text'>
                              {usersErrorState[idx]['email']?.map((err, i) => (
                                <li key={i} style={{ color: 'red' }}>{err}</li>
                              ))}
                            </div>
                          </>)}
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>Perfil:</Form.Label>
                          <Form.Control
                            size='sm'
                            as="select"
                            value={user.profile_id}
                            onChange={e => handleUserChange(idx, 'profile_id', e.target.value)}
                          >
                            <option value={""}>Selecione o Perfil</option>
                            {profiles.map(p => {
                              return <option value={p.id} key={p.id}>{p.name}</option>
                            })}
                          </Form.Control>
                          {usersErrorState[idx] && (<>
                            <div className='display-errors small-text'>
                              {usersErrorState[idx]['profile_id']?.map((err, i) => (
                                <li key={i} style={{ color: 'red' }}>{err}</li>
                              ))}
                            </div>
                          </>)}
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>Telefone:</Form.Label>
                          <MaskedInput
                            mask={getPhoneMask(user.phone??"")}
                            className='form-control'
                            placeholder='(00) 00000-0000'
                            onChange={e => handleUserChange(idx, 'phone', e.target.value)}
                            value={user.phone}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="auto">
                        <Button style={{ position: 'relative', top: '33px' }} size='sm' variant="danger" onClick={() => {
                          Swal.fire({
                            title: 'Tem certeza ?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            cancelButtonText: 'Não',
                            confirmButtonText: 'Sim!'
                          }).then((result) => {
                            if (result.isConfirmed) {
                              if (user.id) {
                                let toDelete = [...usersToDelete]
                                toDelete.push(user)
                                setUsersToDelete([...toDelete])
                              }
                              remove(usersErrorState, idx, setUsersErrorState)
                              remove(usersState, idx, setUsers)
                            }
                          })
                        }}>
                          <Clear fontSize="small" />
                        </Button>
                      </Col>
                    </React.Fragment>
                  )
                })}
                <Col md="12">
                  <Button onClick={() => {
                    push(usersState, { name: "", lastname: "", email: "", phone: "", profile_id: "" }, setUsers)
                    setUsersErrorState([...usersState.map(() => [])])
                  }}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar Usuário
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <h5>Contrato de Adesão:</h5>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" checked={contractAccept} onChange={(e) => setContractAccept(e.currentTarget.checked)} />
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                      Li e concordo com o {' '}
                      <a
                        target='_blank'
                        href={contractUri}
                        onClick={() => { }}
                      >Contrato de Adesão</a>
                    </label>
                  </div>
                </Col>
                <Col md={12}><hr className="line"></hr></Col>
              </Row>
              <Row>
                <Col md="12">
                  <Button
                    disabled={!contractAccept || checkErrors()}
                    onClick={() => setShowModalConfirm(true)}
                    variant="success"
                  >
                    Enviar Dados
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
        <Modal
          size='lg'
          backdrop="static"
          keyboard={false}
          onHide={handleCloseModal}
          show={showModalConfirm}
        >
          <Modal.Header closeButton>
            <Modal.Title>Verifique os dados antes de enviar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Dados da Revenda</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>Razao Social</th>
                      <th>Nome Fantasia</th>
                      <th>CNPJ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{cName}</td>
                      <td>{cAlias}</td>
                      <td>{cDocument}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Endereço</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>CEP</th>
                      <th>Av. / Rua</th>
                      <th>Número</th>
                      <th>Complemento</th>
                      <th>Bairro</th>
                      <th>Estado</th>
                      <th>Cidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{addressZipcode}</td>
                      <td>{address}</td>
                      <td>{addressNumber}</td>
                      <td>{addressComplement}</td>
                      <td>{addressNeighborhood}</td>
                      <td>{addressState}</td>
                      <td>{addressCity}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Filiais</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>Razao Social</th>
                      <th>Nome Fantasia</th>
                      <th>CNPJ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {branchesState?.length == 0 && (
                      <tr>
                        <td colSpan={3}>Sem Filiais</td>
                      </tr>
                    )}
                    {branchesState.map((branch, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{branch.name}</td>
                          <td>{branch.alias}</td>
                          <td>{branch.document}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Card className='mb-2'>
              <Card.Body>
                <Card.Title>Usuários</Card.Title>
                <Table striped bordered className='text-center'>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Sobrenome</th>
                      <th>Email</th>
                      <th>Perfil</th>
                      <th>Telefone</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersState.map((user, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{user.name}</td>
                          <td>{user.lastname}</td>
                          <td>{user.email}</td>
                          <td>{getProfileName(user.profile_id)}</td>
                          <td>{user.phone || "--"}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={isLoading} onClick={() => handleSubmit()}>
              <div className='d-flex align-items-center'>
                <span className={isLoading && 'mr-3'}>Enviar</span>{isLoading && <Spinner animation="border" role="status" size='sm' />}
              </div>
            </Button>
            <Button disabled={isLoading} variant="danger" onClick={handleCloseModal}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  )
}